import { Box } from '@hivebrite/design-system/Box';
import { DefaultLink } from '@hivebrite/design-system/Link';

import PublicationText from 'hb-react/shared/components/Publication/PublicationText';

const NewsText = ({ text, externalUrl }) => (
  <>
    <PublicationText text={text} />
    {externalUrl && (
      <Box my={6}>
        <DefaultLink href={externalUrl} target="_blank">
          {s__('News|Continue reading in website')}
        </DefaultLink>
      </Box>
    )}
  </>
);

export default NewsText;
